import CodeSnippet from 'components/CodeSnippet';
import * as CODE from 'constants/contactsv2';
import { APIWrapper, LeftColumn, RightColumn } from 'components/ApiRef';
import Helmet from 'react-helmet';
import Notification from 'components/Notification';
import * as React from 'react';
export default {
  CodeSnippet,
  CODE,
  APIWrapper,
  LeftColumn,
  RightColumn,
  Helmet,
  Notification,
  React
};